import { clsx } from 'clsx'

export type StakeTabType = 'stake' | 'unstake'

type StakeTabsProps = {
  activeTab: StakeTabType
  onTabChange: (tab: StakeTabType) => void
}

export const StakeTabs = ({ activeTab, onTabChange }: StakeTabsProps) => {
  return (
    <div className="flex items-start gap-1">
      <button
        type="button"
        onClick={() => onTabChange('stake')}
        className={clsx(
          '-ml-4 cursor-pointer px-4 text-2xl font-semibold transition-all',
          activeTab === 'stake' ? 'text-orange' : 'text-gray-80 hover:text-white'
        )}
      >
        Stake
      </button>
      <button
        type="button"
        onClick={() => onTabChange('unstake')}
        className={clsx(
          'cursor-pointer border-l border-gray-100',
          'px-4 text-2xl font-semibold transition-all',
          activeTab === 'unstake' ? 'text-orange' : 'text-gray-80 hover:text-white'
        )}
      >
        Manage
      </button>
    </div>
  )
}
